import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export const useWhyGetawaysPageAnalytics = () => {
  const { pathname } = useLocation();
  const { setAdobePageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.whySouthwestGetaways) {
      setAdobePageData(
        {
          eventinfo: {
            eventtype: "other",
          },
        },
        "whyGetawaysPage"
      );
    }
  }, [pathname]);
};
